@if (downloadable) {
  <button
    class="w-full"
    data-testid="downloadBtn"
    type="button"
    (click)="download.emit()"
  >
    <ng-container *ngTemplateOutlet="content" />
  </button>
} @else {
  <ng-container *ngTemplateOutlet="content" />
}

<ng-template #content>
  <div class="flex h-14 w-full items-center px-5">
    <div
      class="flex w-10 flex-1 items-center gap-x-3 md:w-10 md:justify-between"
    >
      <div class="mr-5 w-1/4 truncate md:w-1/2">
        <span class="text-body-regular truncate text-black" data-testid="name">
          {{ name }}
        </span>
      </div>

      @if (!uploading && (size || formattedExtension)) {
        <div
          class="text-body-small mt-1 flex w-1/2 select-none items-center justify-center gap-x-1 text-po-gray-1000"
        >
          @if (size) {
            <span data-testid="size">
              {{ size | fileSize }}
            </span>
          }

          @if (size && formattedExtension) {
            <span class="h-1 w-1 rounded-full bg-po-gray-1000"></span>
          }

          @if (formattedExtension) {
            <span class="uppercase" data-testid="extension">
              {{ formattedExtension }}
            </span>
          }
        </div>
      }

      @if (uploading) {
        <div class="flex w-1/2 select-none items-center justify-center">
          <div class="flex flex-1 items-center gap-x-4">
            <aw-progress-bar
              class="flex-1"
              data-testid="uploadProgressBar"
              [progress]="uploadProgress"
            />

            @if (uploadSpeed !== undefined && uploadSpeed !== null) {
              <span
                class="text-body-small text-po-gray-1000"
                data-testid="uploadSpeed"
              >
                {{ uploadSpeed | fileSize }}/s
              </span>
            }
          </div>
        </div>
      }
    </div>
    <div class="flex w-1/3 justify-end">
      @if (removable) {
        <button
          class="flex items-center gap-x-1 text-po-error-base"
          awRipple
          data-testid="removeBtn"
          data-cy="removeBtn"
          type="button"
          (click)="onRemove($event)"
        >
          <aw-icon class="w-2.5" icon="trash-can" />
          <span class="text-cta-small uppercase">remove</span>
        </button>
      }
    </div>
  </div>
</ng-template>
